module.exports = __webpack_public_path__ + "static/media/plastazote.67fd35f8.png";